<template>
    <a-modal
      title="Confirmation"
      :visible="modalEdit"
      @ok="handleModalEditOk"
      @cancel="handleCancel"
      :confirmLoading="confirmLoading"
      :maskClosable="false"
    >
      <loading v-if="anggaran.loadingtree" />
      <a-form :form="formEditModal">
        <a-form-item label="Ticket Type">
          <a-radio-group
            v-decorator="[
              'type_ticket',
              {
                rules: [{ required: true }],
                initialValue: data.type_ticket,
              },
            ]"
            button-style="solid"
          >
            <a-radio-button value="Bus">Bus</a-radio-button>
            <a-radio-button value="Car">Car</a-radio-button>
            <a-radio-button value="Flight">Flight</a-radio-button>
            <a-radio-button value="Hotel">Hotel</a-radio-button>
          </a-radio-group>
        </a-form-item>

        <a-form-item label="User Booking">
          <a-select
            showSearch
            v-decorator="['user_booking',
                  {
                      rules: [{ required: true }],
                      initialValue: data.user_booking
                  },
              ]"
            :filterOption="filterOption"
          >
            <a-select-option v-for="item in getAllKaryawan" :key="item.tlc">
              {{item.tlc}} - {{item.nama}}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="No. Booking">
          <a-input v-decorator="['no_booking', { rules: [{ required: true }], initialValue: data.no_booking }]"></a-input>
        </a-form-item>
        
        <a-form-item label="Description">
          <a-input
            v-decorator="['deskripsi', {rules: [{required: true}], initialValue: data.deskripsi}]"
          ></a-input>
        </a-form-item>

        <a-row :gutter="16">
          <a-col :span="13">
            <a-form-item label="Budget Type">
              <a-radio-group
                v-decorator="[
                  'category',
                  {
                    rules: [{ required: false }],
                    initialValue: (data.cost_center ? 'COST_CENTER' : (data.id_sppd ? 'SPPD' : 'PP')),
                  },
                ]"
                ref="refcategory"
                button-style="solid"
              >
                <a-radio-button value="SPPD">SPPD</a-radio-button>
                <a-radio-button value="PP">PP</a-radio-button>
                <a-radio-button value="COST_CENTER">COST CENTER</a-radio-button>
              </a-radio-group>
            </a-form-item>
          </a-col>
          <a-col :span="11">
            <a-form-item label="SPPD No" v-if="!$refs.refcategory || ($refs && $refs.refcategory && $refs.refcategory.value=='SPPD')">
            <a-select
                showSearch
                :not-found-content="null"
                option-filter-prop="children"
                v-decorator="['sppd_no', { rules: [{ required: false }], initialValue: data.id_sppd}]"
                :default-active-first-option="false"
                :filter-option="false"
                placeholder="Type to Search"
                @search="handleSearchSPPD"
                @change="onChangeSppdNo"
            >
                <a-select-option v-for="item in dataSPPDList" :key="item.id_sppd">
                    {{item.no_sppd}}
                </a-select-option>
            </a-select>
            </a-form-item>
            <a-form-item label="PP No" v-if="$refs && $refs.refcategory && $refs.refcategory.value=='PP'">
              <a-select
                showSearch
                :not-found-content="null"
                option-filter-prop="children"
                :default-active-first-option="false"
                :filter-option="false"
                v-decorator="['pp_no', { rules: [{ required: false }], initialValue: data.id_pp}]"
                placeholder="Type to Search"
                @search="handleSearchPP"
                @change="onChangePPNo"
              >
                <a-select-option v-for="item in dataPPList" :key="item.id_pp">
                  {{item.no_pp}}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="Cost Center" v-if="$refs && $refs.refcategory && $refs.refcategory.value=='COST_CENTER'">
              <a-select
                showSearch
                :not-found-content="null"
                option-filter-prop="children"
                :default-active-first-option="false"
                :filter-option="false"
                v-decorator="['cost_center', { rules: [{ required: false }], initialValue: data.cost_center}]"
                placeholder="Type to Search"
                @search="handleSearchCostCenter"
                @change="onChangeCostCenter"
              >
                <a-select-option v-for="item in dataPPList" :key="item.id">
                  {{item.label}}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>

        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-item label="End User Type">
              <a-radio-group
                v-decorator="[
                  'type_user',
                  {
                    rules: [{ required: true }],
                    initialValue: data.end_user ? 'employee' : 'foreigner',
                  },
                ]"
                ref="reftype_user"
                button-style="solid"
              >
                <a-radio-button value="employee">Employee</a-radio-button>
                <a-radio-button value="foreigner">Foreigner</a-radio-button>
              </a-radio-group>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="End User" v-if="!$refs.reftype_user || ($refs && $refs.reftype_user && $refs.reftype_user.value=='employee')">
              <a-select
                  showSearch
                  v-decorator="['end_user',
                      {
                          rules: [{ required: true }], initialValue: data.end_user
                      },
                  ]"
              >
                  <a-select-option v-for="item in getCCEmpList" :key="item.tlc">
                    {{item.tlc}} - {{item.nama}}
                  </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="Foreigner Name" v-if="$refs && $refs.reftype_user && $refs.reftype_user.value=='foreigner'">
              <a-input v-decorator="['end_user_name', { rules: [{ required: true }], initialValue: data.nama }]"></a-input>
            </a-form-item>
          </a-col>
        </a-row>
  
        <a-form-item label="Credit">
          <a-input-number
            :min="0"
            @keydown="onlyNumber"
            class="m-width-full m-text-align-right"
            :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
            :parser="value => value.replace(/\Rp\s?|(,*)/g, '')"
            v-decorator="['kredit', {rules: [{required: true},{validator:checkPrice}], initialValue: data.kredit}]"
          />
        </a-form-item>
  
        <a-form-item label="Expense Date">
          <a-date-picker
            placeholder="Select Date"
            :format="getDefaultDateFormat"
            v-decorator="['tanggal_pengeluaran', {rules: [{required: true}],
                  initialValue: moment(data.tanggal_pemakaian)}]"
          />
        </a-form-item>

        <a-form-item label="Upload Transaction Document">
          <a-upload
            :showUploadList="true"
            :fileList="doctransfiles"
            :beforeUpload="beforedoctransUpload"
            :remove="handledoctransRemove"
            v-decorator="['doctrans', { valuePropName: 'doctransfiles' }]"
          >
            <a-button>
              <a-icon type="upload" />&nbsp;Select File
            </a-button>
          </a-upload>
        </a-form-item>
      </a-form>

      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleModalEditOk">Submit</a-button>
      </template>
    </a-modal>
  </template>
  
  <script>
  import { mapGetters } from "vuex";
  import moment from "moment";
  import axios from "axios";
  import CurrencyFormat from "@/mixins/CurrencyFormat";
  import Loading from "@/components/preloader/Loading.vue";
  import GlobalMethod from "@/mixins/GlobalMethod.js";
  

  let SPPDCombotimeout;
  let SPPDcurrentValue;

  function fetchLazySPPD(source, value, callback) {
    if (SPPDCombotimeout) {
      clearTimeout(SPPDCombotimeout);
      SPPDCombotimeout = null;
    }
    SPPDcurrentValue = value;

    function lazySPPD() {
      const data = []
      if(SPPDcurrentValue){
        const result = source.filter(item=> item.no_sppd.toLowerCase().includes(SPPDcurrentValue.toLowerCase()))
        result.forEach(r => {
          data.push({
            id_sppd: r.id_sppd,
            no_sppd: r.no_sppd,
          });
        });
      }
        callback(data);
      }

    SPPDCombotimeout = setTimeout(lazySPPD, 300);
  }

  let PPCombotimeout;
  let PPcurrentValue;

  function fetchLazyPP(source, value, callback) {
    if (PPCombotimeout) {
      clearTimeout(PPCombotimeout);
      PPCombotimeout = null;
    }
    PPcurrentValue = value;

    function lazyPP() {
      const data = []
      if(PPcurrentValue){
        const result = source.filter(item=> item.no_pp.toLowerCase().includes(PPcurrentValue.toLowerCase()))
        result.forEach(r => {
          data.push({
            id_pp: r.id_pp,
            no_pp: r.no_pp,
          });
        });
      }
        callback(data);
      }

    PPCombotimeout = setTimeout(lazyPP, 300);
  }

  let CostCenterCombotimeout;
  let CostCentercurrentValue;

  function fetchLazyCostCenter(source, value, callback) {
    if (CostCenterCombotimeout) {
      clearTimeout(CostCenterCombotimeout);
      CostCenterCombotimeout = null;
    }
    CostCentercurrentValue = value;

    function lazyCostCenter() {
      const data = []
      if(CostCentercurrentValue){
        const result = source.filter(item=> item.text.toLowerCase().includes(CostCentercurrentValue.toLowerCase()))
        result.forEach(r => {
          data.push({
            id: r.text,
            label: r.text,
          });
        });
      }
        callback(data);
      }

    CostCenterCombotimeout = setTimeout(lazyCostCenter, 300);
  }

  export default {
    props: {
      dataList: {},
      confirmLoading: Boolean,
      modalEdit: Boolean,
      data: {},
      getCostCenter: {},
      getPeruntukan: {},
      getSubPeruntukan: {},
      getAnggaran: {},
    },
    mixins: [CurrencyFormat,GlobalMethod],
    components: {
      Loading,
    },
    computed: {
      ...mapGetters([
        "getDefaultDateFormat",
        "getAuth",
        "getActiveProjectkk",
        "getAlokasi",
        "getUsedFor",
        "getJenisAnggaran",
        "getEndUserCC",
        "getSppdNoList",
        "getMARDEVActivity",
        "getSppdNoList",
        "getCCPPNoList",
        "getCCEmpList",
        "getAllKaryawan",
      ]),
      project() {
        return this.getActiveProjectkk.filter((obj) => obj.kategori);
      },
    },
    data() {
      return {
        loading: false,
        kategori: "",
        peruntukan: [],
        subPeruntukan: [],
        costCenter: [],
        end_user_list: [],
        anggaran: {
          peruntukan_id: "",
          anggaran_id: "",
          id_pp: "",
          modalvalue: undefined,
          path: "",
          limit: 0,
          tree: [],
          treeModal: [],
          searchValue: "",
          loadingtree: false,
        },
        treeExpandedKeys: [],
        // EnCommission: false,
        Viwithout_note: false,
        doctransfiles: [],
        pipelineList: [],
        load:{
          pipeline: false
        },
        activity_type: null,
        activity: null,
        selectedCostCenter: null,
        listProspect: [],
        dataSPPDList: [],
        dataPPList: []
      };
    },
    created() {
      this.$store.dispatch("FETCH_ENDUSER_CC");
      this.$store.dispatch("FETCH_SPPD_NO_LIST");

      this.formEditModal = this.$form.createForm(this);
      if (this.getPeruntukan !== undefined) {
        if(this.data.cost_center_id){
        const peruntukan = this.getPeruntukan.filter(
          (obj) =>
            obj.anggaran_id
              .toLowerCase()
              .indexOf(this.data.cost_center_id.toLowerCase()) >= 0
        );
        this.peruntukan = peruntukan;
        }else{
          this.peruntukan = {};
        }
      }
      if (this.getSubPeruntukan !== undefined) {
        if(this.data.peruntukan_id){
        const filter = this.getSubPeruntukan.filter(
          (obj) =>
            obj.peruntukan_id
              .toLowerCase()
              .indexOf(this.data.peruntukan_id.toLowerCase()) >= 0
        );
        this.subPeruntukan = filter;
        }else{
          this.subPeruntukan = {}
        }
      }
  
      let filtera = {};
      if (this.getAnggaran !== undefined) {
        if(this.data.sub_peruntukan_id){
          filtera = this.getAnggaran.filter(
            (obj) =>
              obj.anggaran_dtl_id
                .toLowerCase()
                .indexOf(this.data.sub_peruntukan_id.toLowerCase()) >= 0
          );
        }
        //this.anggaran = filtera;
      }
      if (this.getCostCenter !== undefined) {
        if(this.data.cost_center_id){
          filtera = this.getCostCenter.filter(
            (obj) =>
              obj.value
                .toLowerCase()
                .indexOf(this.data.cost_center_id.toLowerCase()) >= 0
          );
        }
  
        this.costCenter = filtera;
      }
    },
    async mounted() {
        this.$store.dispatch("FETCH_ALL_KARYAWAN");
        this.doctransfiles = this.data.doctransfiles;
        this.$nextTick(() => {
            this.formEditModal.setFieldsValue({
                sppd_no: this.data.id_sppd
            })

            this.onChangeSppdNoMounted(this.data.id_sppd)

            if(this.data.no_sppd)
              this.handleSearchSPPD(this.data.no_sppd)
            if(this.data.no_pp)
              this.handleSearchPP(this.data.no_pp)
            if(this.data.cost_center)
              this.handleSearchCostCenter(this.data.cost_center)
        })
    },
    watch:{
      data(){
        if(this.data.id){
        }
      }
    },
    methods: {
      moment,
      getParent(root) {
        let data = [];
        root.forEach((item) => {
          if (item.key) {
            data.push(item.key);
          }
  
          if (item.children.length > 0) {
            item.children.forEach((d) => {
              data.push(d.key);
            });
          }
        });
        return data;
      },
    //   onChangeSppdNo(e) {
    //     this.end_user_list = []
    //     this.formEditModal.resetFields([
    //       "end_user",
    //     ]);
    //     const filter = this.getSppdNoList.find((dt) => e == dt.id_sppd );
    //     this.end_user_list = filter.assignee
    //   },
    // onChangeSppdNo(e) {
    //     this.end_user_list = []
    //     this.formEditModal.resetFields([
    //         "end_user",
    //     ])
    //     this.data.end_user = null

    //     const filter = this.getSppdNoList.find(
    //         dt => String(dt.id_sppd) === String(e)
    //     )

    //     if (!filter) {
    //         return
    //     }

    //     this.end_user_list = filter.assignee || []
    // },
    onChangeSppdNoMounted(e) {
        this.end_user_list = []
        const filter = this.getSppdNoList.find(
            dt => String(dt.id_sppd) === String(e)
        )
        if (!filter) {
            return
        }
        this.end_user_list = filter.assignee || []
    },

      filterTreeNode(input, option) {
        //console.log(input, option)
        return (
          option.data.props.texttitle == undefined ||
          (option.data.props.texttitle ? option.data.props.texttitle : "")
            .toLowerCase()
            .indexOf(input.toLowerCase()) >= 0 ||
          (option.data.props.kode_anggaran ? option.data.props.kode_anggaran : "")
            .toLowerCase()
            .indexOf(input.toLowerCase()) >= 0
        );
      },
      handlechoiceCost(value, record) {
        this.data.limit = record.dataRef.rekap;
        this.data.path = record.dataRef.path;
      },
      filterOption(input, option) {
        return (
          option.componentOptions.children[0].text
            .toLowerCase()
            .indexOf(input.toLowerCase()) >= 0
        );
      },
      async handle_Cost(e) {
        await this.initialPipeline(e)
        //console.log("jos")
        this.$nextTick(function () {
          //this.formEditModal.resetFields(["peruntukan", "sub_peruntukan", "kode_anggaran"]);
          this.formEditModal.setFieldsValue({
            peruntukan: null,
            sub_peruntukan: null,
            kode_anggaran: null,
          });
        });
        this.subPeruntukan = [];
        this.anggaran.tree = [];
        this.anggaran.treeModal = [];
        const peruntukan = this.getPeruntukan.filter(
          (obj) => obj.anggaran_id.toLowerCase().indexOf(e.toLowerCase()) >= 0
        );
        this.peruntukan = peruntukan;
        this.anggaran.anggaran_id = e;
        this.data.cost_center_id = e;
      },
      handle_Peruntukan(e) {
        //console.log("handleEdit",e)
        this.$nextTick(function () {
          //this.formEditModal.resetFields(["sub_peruntukan", "kode_anggaran"]);
          this.formEditModal.setFieldsValue({
            sub_peruntukan: null,
            kode_anggaran: null,
          });
        });
        this.anggaran.tree = [];
        this.anggaran.treeModal = [];
        this.anggaran.peruntukan_id = e;
        this.data.peruntukan_id = e;
        const filter = this.getSubPeruntukan.filter(
          (obj) => obj.peruntukan_id.toLowerCase().indexOf(e.toLowerCase()) >= 0
        );
        this.subPeruntukan = filter;
        let arr = this.dataList.filter((item) => item.kredit !== "");
        //this.recountAnggaran(arr);
      },
      handle_SubPeruntukan(e) {
        this.$nextTick(function () {
          //this.formEditModal.resetFields(["kode_anggaran"]);
          this.formEditModal.setFieldsValue({
            kode_anggaran: null,
          });
        });
        const filter = this.getAnggaran.filter(
          (obj) => obj.anggaran_dtl_id.toLowerCase().indexOf(e.toLowerCase()) >= 0
        );
        //this.anggaran = filter;
      },
      handleCancel(e) {
        Event.$emit("modalCancel", false);
        this.formEditModal.resetFields();
        //console.log(this.$refs)
        Event.$emit("resetdtlpemakaian", true);
      },
      handleModalEditOk() {
        this.formEditModal.validateFields((err, values) => {
          if (err) {
            this.displayMessage("form-warning");
            return;
          }
  
          if(moment(values.tanggal_pengeluaran).format('YYYY-MM-DD')>moment().format('YYYY-MM-DD')){
            this.displayMessageValue("error-other", "Expense date can't exceed today!");
            return;
          }
  
          //antisipasi error bigint postgresql
          if (this.dataList.length > 0) {
            let nom = (10 * parseFloat(this.dataList[0].debit)) / 100;
            if (values.kredit > nom) {
              this.displayMessageValue(
                "error-other",
                "The value max is 10% from debet!"
              );
              return;
            }
          }
  
          //console.log(values)
          if (parseFloat(this.data.limit) < values.kredit) {
            this.displayMessageValue(
              "limit-anggaran",
              this.formatRupiah(this.data.limit)
            );
            return;
          } else {
            this.loading = true;
            let url = this.data.type === "revised" ? 
            "lap_tiket_pd/dtl_revisi_edit" : "lap_tiket_pd/dtl_draft_edit";

            let addData = new FormData();
            addData.append("tlc", this.getAuth.username);
            addData.append("id", this.data.id);
            // addData.append("id_klaim", this.data.id_klaim);
            addData.append("expense_date", values.tanggal_pengeluaran.format("YYYY-MM-DD"));
            addData.append("description", values.deskripsi);
            addData.append("credit", values.kredit);

            if(values.end_user){
              addData.append("end_user", values.end_user);
              addData.append("end_user_name", this.getCCEmpList.filter(item=>item.tlc==values.end_user)[0].nama);
            }
            if(values.end_user_name)
              addData.append("end_user_name", values.end_user_name);

            addData.append("id_user_cc", this.data.id_user_cc);
            if(values.sppd_no)
              addData.append("sppd_no", values.sppd_no);
            if(values.pp_no)
              addData.append("pp_no", values.pp_no);
            if(values.cost_center)
              addData.append("cost_center", values.cost_center);

            if (this.doctransfiles && this.doctransfiles.length > 0) {
              this.doctransfiles.forEach((file) => {
                addData.append("file_upload", file);
              });
            }
            addData.append("no_booking", values.no_booking);
            addData.append("user_booking", values.user_booking);
            addData.append("tipe_tiket", values.type_ticket);
  
            axios({
              method: "post",
              url: this.$serviceUrl + url,
              processData: false,
              data: addData,
              auth: {
                username: this.getAuth.username,
                password: this.getAuth.password,
              },
              headers: {
                // "Content-Type": "application/json",
                "X-API-KEY": this.getAuth.apikey,
              },
            })
              .then((response) => {
                this.loading = false;
                this.formEditModal.resetFields();
                Event.$emit("modalCancel", false);
                Event.$emit("fetchPemakaian", true);
                Event.$emit("resetdtlpemakaian", true);
              })
              .catch((err) => {
                this.loading = false;
                Event.$emit("resetdtlpemakaian", true);
                let responses = Object.assign({}, err.response.data);
                this.displayMessageValue("error-other", responses.message);
                console.log("error : " + err);
              });
          }
        });
      },
      checkPrice(rule, value, callback) {
        if (value > 0) {
          callback();
          return;
        }
        callback("Price must greater than zero!");
      },
      handleProyek(value) {
        let filter = this.project.filter(
          (obj) =>
            obj.kode_project.toLowerCase().indexOf(value.toLowerCase()) >= 0
        );
  
        this.kategori = filter[0].kategori;
        this.formEditModal.setFieldsValue({
          alokasi: "",
        });
      },
      handleJenisAnggaran(e) {
        this.selectedCostCenter = e
        this.data.prospek = null
        this.listProspect = []
        this.formEditModal.setFieldsValue({
          cost_center: null,
          peruntukan: null,
          sub_peruntukan: null,
          kode_anggaran: null,
          prospek: null
        });
        const filter = this.getCostCenter.filter(
          (obj) => obj.jns_anggaran_id.toLowerCase().indexOf(e.toLowerCase()) >= 0
        );
  
        this.costCenter = filter;
        this.peruntukan = [];
        this.anggaran.tree = [];
        this.anggaran.treeModal = [];
        this.subPeruntukan = [];
      },
      filterOptionTlc(input, option) {
        return (
          option.componentOptions.children[0].text
            .toLowerCase()
            .indexOf(input.toLowerCase()) >= 0
        );
      },
      handleOptionCommission(val){
        if(val.target.value=="1"){
          this.Viwithout_note = false;
        }else{
          this.Viwithout_note = true;
        }
        this.$nextTick(function () {
          this.formEditModal.setFieldsValue({
              without_note: "1",
          });
        });
      },
      handleChangeumDtl(val){
        let selectedumDtl = _.filter(this.data.ppdetillist, { id_um_dtl: val });
        //console.log(selectedumDtl,this.ppdetillist);
        if(selectedumDtl[0] && selectedumDtl[0].is_komisi){
          // this.EnCommission = true;
          this.Viwithout_note = false;
          this.$nextTick(function () {
            this.formEditModal.setFieldsValue({
                iscommision: "1",
                without_note: "0",
            });
          });
        }else{
          // this.EnCommission = false;
          this.Viwithout_note = true;
          this.$nextTick(function () {
            this.formEditModal.setFieldsValue({
                iscommision: "0",
                without_note: "0",
            });
          });
        }
      },
      beforedoctransUpload(file) {
        const FileSize = file.size / 1024 / 1024;
        if (FileSize > 5) {
          this.displayMessage("large-file-5mb");
        } else {
          this.doctransfiles = [file];
          return false;
        }
      },
      handledoctransRemove() {
        this.doctransfiles = [];
      },
      async initialPipeline(e){
        this.load.pipeline = true
        await axios({
          method: "get",
          url: this.$serviceUrl + "klaim_direktur/pipeline",
          params: {
            anggaran_id: e,
            tlc: this.getAuth.username,
          },
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey,
          },
        })
        .then((response) => {
          this.load.pipeline = false
          this.pipelineList = response.data.data?response.data.data:[]
        })
        .catch((err) => {
          let responses = Object.assign({}, err.response);
          this.displayMessageValue("error", responses);
        });
      },
      changeActivity_type(val){
        if(val=="Non Project"){
          this.data.activity = null
          this.$nextTick(function () {
            this.formEditModal.setFieldsValue({
              activity: null,
            });
          });
        }else{
          this.data.pipeline_id = null
          this.$nextTick(function () {
            this.formEditModal.setFieldsValue({
                pipeline_id: null,
            });
          });
        }
      },
      async getProspectList(){
        await axios({
          method: "get",
          url: this.$serviceUrl + "prospek/pilih_prospek",
          params: {
            anggaran_id: this.anggaran.anggaran_id
          },
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey,
          },
        })
        .then(async (response) => {
          this.listProspect = response.data.data ? response.data.data : [];
          this.anggaran.loadingtree = false;
        })
        .catch(() => {
        });
      },
      handleSearchSPPD(value) {
        const list = this.getSppdNoList
        fetchLazySPPD(list, value, data => (this.dataSPPDList = data));
      },
      onChangeSppdNo(e) {
        const list = this.getSppdNoList
        fetchLazySPPD(e, data => (list, this.dataSPPDList = data))
      },
      handleSearchPP(value) {
        const list = this.getCCPPNoList
        fetchLazyPP(list, value, data => (this.dataPPList = data));
      },
      onChangePPNo(e) {
        const list = this.getCCPPNoList
        fetchLazyPP(list, e, data => (list, this.dataPPList = data))
      },
      handleSearchCostCenter(value) {
        const list = this.getCostCenter
        fetchLazyCostCenter(list, value, data => (this.dataPPList = data));
      },
      onChangeCostCenter(e) {
        const list = this.getCostCenter
        fetchLazyCostCenter(list, e, data => (list, this.dataPPList = data))
      },
    },
  };
  </script>
  
  <style>
  </style>